import { createFileRoute } from "@tanstack/react-router";

import { useViewer } from "../data/hooks.ts";
import { loadManualImport } from "../manual/loaders.ts";
import { ManualImportScreen } from "../manual/manual-page.tsx";
import { ManualPending } from "../manual/pending.tsx";
import { isManualCurator } from "../manual/permissions.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";

import type { ReactElement } from "react";

const Page = (): ReactElement => {
  const viewer = useViewer();
  return viewer === null || !isManualCurator(viewer) ? (
    <NoAccessPage />
  ) : (
    <ManualImportScreen viewer={viewer} />
  );
};

export const Route = createFileRoute("/_app/manual/import")({
  loader: async ({ context }) => loadManualImport(context.data),
  pendingComponent: ManualPending,
  component: Page,
});
